<div class="rep-documents-page" hrtDndFile data-message="Drop a file to add a Rep Document"
	[class.document-dialog-open]="isDocumentDialogOpen"
	(fileDropped)="onPageFilesDropped($event, documentDialog)">
<geaui-page-content-layout class="rep-documents-layout">
  <ng-container page-header>
<geaui-page-header pageTitle="Rep Documents" [hasBackArrow]="false" [withSidebar]="true">
	<div class="rep-documents-page-header-container">
		<mat-checkbox
			*ngIf="canEditDocuments"
			[checked]="showArchived"
			(change)="setShowArchived($event.checked)"
		>Show Archived</mat-checkbox>
    <geaui-button-v3
      *ngIf="canEditDocuments"
      [disabled]="!canEditDocuments"
      [type]="'primary'"
      (click)="openAddDocument(documentDialog)"
      >Add Document</geaui-button-v3
    >
  </div>
</geaui-page-header>
  </ng-container>

  <ng-container page-content>
<div class="rep-documents-content geaui-grid geaui-sidebar-grid geaui-scrollable-table-2-rows">
	<div class="rep-documents-filters geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12">
		<geaui-search-bar-v2
			[id]="'rep-documents-search'"
			[group]="searchForm"
			formName="search"
			[placeholder]="'Search Rep Documents'"
			[showBottomBorderOnly]="true"
			[hasSuggestions]="false"
			[hasProminentButton]="false"
			(valueChanged)="searchValueChanged($event)"
			(clearEvent)="clearSearch()">
		</geaui-search-bar-v2>
		<hrt-filter-chips
			[columnDefinitions]="columnDefinitions"
			[activeChipFilters]="activeChipFilters"
			[globalSearch]="'Rep Documents Search'"
			[tableId]="tableId"
			(chipRemoved)="onChipRemoved($event)">
		</hrt-filter-chips>
	</div>

	<p *ngIf="pageMessage" class="page-message" role="status">{{ pageMessage }}</p>

  <geaui-table-v3
	  [tableId]="tableId"
    [columnDefinitions]="columnDefinitions"
    [data]="tableRows"
    [totalRecords]="totalRows"
    [loading]="isTableLoading"
    [isLandingPage]="true"
	  [sortable]="false"
    [noEntriesInfoText]="'No entries available, try a different search.'"
	[noEntriesTitle]="'No Rep Documents Found'"
	class="rep-documents-table geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12 geaui-col-tablet-lg-12 geaui-col-tablet-sm-12 geaui-col-phone-lg-8 geaui-col-phone-sm-4">
  </geaui-table-v3>
</div>
  </ng-container>
</geaui-page-content-layout>

<ng-template #documentDialog>
	<h2 mat-dialog-title>{{ draft.Id ? 'Edit Document' : 'Add Document' }}</h2>
	<mat-dialog-content class="document-form">
		<label class="form-field">
			<span>Title</span>
			<input type="text" [(ngModel)]="draft.Title" maxlength="250" required />
		</label>
		<label class="form-field">
			<span>Description</span>
			<textarea rows="3" [(ngModel)]="draft.Description"></textarea>
		</label>
		<label class="form-field">
			<span>Department</span>
			<select [(ngModel)]="draft.DepartmentId">
				<option *ngFor="let department of departments" [ngValue]="department.id">
					{{ department.description }}
				</option>
			</select>
		</label>
		<label class="form-field">
			<span>Category</span>
			<select [(ngModel)]="draft.CategoryId">
				<option *ngFor="let category of categories" [ngValue]="category.id">
					{{ category.description }}
				</option>
			</select>
		</label>
		<label class="form-field">
			<span>Created By</span>
			<input type="text" [value]="draft.Id ? draft.CreatedByUserName : currentUserName" disabled />
		</label>
		<div class="upload-field" hrtDndFile data-message="Drop file to upload"
			(fileDropped)="onFilesDropped($event)">
			<input #documentFile type="file" class="visually-hidden" (change)="onFileSelected($event)" />
			<button class="geaui-button-secondary" type="button" (click)="documentFile.click()">
				<mat-icon>upload_file</mat-icon>
				Upload Document
			</button>
			<span>{{ selectedFile?.name || draft.Filename || 'No file selected' }}</span>
		</div>
    		<p *ngIf="dialogMessage" class="dialog-message" role="alert">{{ dialogMessage }}</p>
		<mat-checkbox *ngIf="draft.Id" [(ngModel)]="draft.IsArchived">Archive</mat-checkbox>
	</mat-dialog-content>
	<mat-dialog-actions class="document-dialog-actions" align="end">
		<button class="geaui-button-primary" type="button" [disabled]="isSaving" (click)="saveDocument()">
			{{ isSaving ? 'Saving...' : 'Save' }}
		</button>
		<button class="geaui-button-secondary" type="button" [disabled]="isSaving" (click)="cancelEdit()">
			Cancel
		</button>
	</mat-dialog-actions>
</ng-template>
</div>